export default __webpack_public_path__ + "static/media/backgroud-cloubvspresi.d97b3dc1.jpeg";